import { Flex, Image, Text } from '@chakra-ui/react'
import React from 'react'
import { formatPrice } from '../../../../../../utils/formatPrice'

export const Produto = ({
  nome_produto,
  cor_produto,
  impressoes,
  personalizacao,
  prazo,
  quantidade,
  imagem_produto,
  valor_chegar,
  valor_atual,
  codigo_produto,
}) => {
  return (
    <Flex flexDir="column" fontSize="12px" gap={1}>
      <Text>
        <strong>Item:</strong> {nome_produto}
      </Text>
      <Text fontWeight="bold" fontSize="15px">
        <Text as="span" color="#378BBF">
          COD INNOVATION:
        </Text>{' '}
        {codigo_produto}
      </Text>

      <Image src={imagem_produto} width="72px" height="99px" borderRadius="md" border="1px solid #CFCFCF" />

      <Text>
        <strong>COR:</strong> {cor_produto}
      </Text>
      <Text>
        <strong>IMPRESSÃO:</strong> 1
      </Text>
      <Text>
        <strong>PERSONALIZAÇÃO:</strong> {personalizacao}
      </Text>
      <Text>
        <strong>PRAZO:</strong> {prazo} dias úteis
      </Text>
      <Text>
        <strong>QUANTIDADE:</strong> {quantidade}
      </Text>
      <Text>
        <Text fontWeight="bold" as="span" color="#378BBF">
          PREÇO SITE:
        </Text>{' '}
        {formatPrice(valor_atual)}
      </Text>
      <Text>
        <Text fontWeight="bold" as="span" color="#378BBF">
          PREÇO PARA CHEGAR:
        </Text>{' '}
        {formatPrice(valor_chegar)}
      </Text>
    </Flex>
  )
}
